import React, { FC, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import classNames from 'classnames';
import { ShareSocialButton, ShareProviders } from './components/ShareSocialButton';

import * as Types from 'types';

type Props = {
  url: string;
  title: string;
};

export const ShareModalContent: FC<Props> = ({ url, title }) => {
  const [copied, setCopied] = useState(false);

  return (
    <>
      <div
        className='copy-text-component copy-text-component--small mb-1 d-flex'
        style={{ width: '100%' }}
      >
        <div className='copy-text-component__input' style={{ width: '100%' }}>
          <input
            className='input-blended text-truncate'
            readOnly
            style={{ width: '100%' }}
            type='text'
            value={url}
          />
        </div>
        <div className='copy-text-component__button' style={{ marginLeft: 'auto' }}>
          <CopyToClipboard
            text={url}
            onCopy={() => {
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
            }}
          >
            <button className='btn btn--medium bg-black' type='button'>
              Copy
              <div
                className={classNames('tooltip', 'tooltip--centered', {
                  'tooltip--invisible': !copied,
                })}
                data-placement='top'
                role='tooltip'
                style={{ bottom: '100%' }}
              >
                <div className='tooltip__arrow' />
                <div className='tooltip__inner'>Copied</div>
              </div>
            </button>
          </CopyToClipboard>
        </div>
      </div>
      <div className='d-flex flex-column align-items-start text-dark mb-1'>
        <ShareSocialButton
          key={ShareProviders.twitter}
          title={title}
          url={url}
          provider={ShareProviders.twitter}
        />
        <ShareSocialButton
          key={ShareProviders.facebook}
          url={url}
          provider={ShareProviders.facebook}
        />
      </div>
    </>
  );
};
